
export class DistributionPromo { 
    private id: number
    public get _id(): number {
        return this._id;
    }
    public set _id(value: number) {
        this.id = value;
    }

    private distribution_id: number;
    public get _distribution_id(): number {
        return this.distribution_id;
    }
    public set _distribution_id(value: number) {
        this.distribution_id = value;
    }
    private max_sku_qty: number;
    public get _max_sku_qty(): number {
        return this.max_sku_qty;
    }
    public set _max_sku_qty(value: number) {
        this.max_sku_qty = value;
    }
    private max_sku_reset_period: string;
    public get _max_sku_reset_period(): string {
        return this.max_sku_reset_period;
    }
    public set _max_sku_reset_period(value: string) {
        this.max_sku_reset_period = value;
    }
    private max_sku_reset_period_qty: number;
    public get _max_sku_reset_period_qty(): number {
        return this.max_sku_reset_period_qty;
    }
    public set _max_sku_reset_period_qty(value: number) {
        this.max_sku_reset_period_qty = value;
    }
    private discount_type_id: number;
    public get _discount_type_id(): number {
        return this.discount_type_id;
    }
    public set _discount_type_id(value: number) {
        this.discount_type_id = value;
    }
    private discount_compute_rounding: string;
    public get _discount_compute_rounding(): string {
        return this.discount_compute_rounding;
    }
    public set _discount_compute_rounding(value: string) {
        this.discount_compute_rounding = value;
    }
    private discount_compute_decimal_places: number;
    public get _discount_compute_decimal_places(): number {
        return this.discount_compute_decimal_places;
    }
    public set _discount_compute_decimal_places(value: number) {
        this.discount_compute_decimal_places = +value;
    }
    private purchase_is_accumulated: number;
    public get _purchase_is_accumulated(): number {
        return this.purchase_is_accumulated;
    }
    public set _purchase_is_accumulated(value: number) {
        this.purchase_is_accumulated = value;
    }

    private discount_tier: number;
    public get _discount_tier(): number {
        return this.discount_tier;
    }
    public set _discount_tier(value: number) {
        this.discount_tier = value
    }

    private mechanic_period_basis: string;
    public get _mechanic_period_basis(): string {
        return this.mechanic_period_basis;
    }
    public set _mechanic_period_basis(value: string) {
        this.mechanic_period_basis = value
    }

    private is_active: number; 
    public get _is_active(): number {
        return this.is_active;
    }
    public set _is_active(value: number) {
        this.is_active = value;
    }
}

